import _ from 'underscore';

const cacheUI = (el, keys) => {
    if (keys) {
        const values = keys.map((value) => {
            const elements = el.querySelector(`[data-ui="${value}"]`);
            if (elements === null || elements.length === 0) {
                console.warn(`Couldn't find element with data-ui="${value}" on ${el}`);
            }

            if (elements.length === 1) {
                return elements[0];
            }
            return elements;
        });

        return _.object(keys, values);
    }
    const elements = el.querySelectorAll('[data-ui]');
    const newKeys = [];
    _.forEach(elements, (childEl) => {
        newKeys.push(childEl.dataset.ui);
    });
    return _.object(newKeys, elements);
};

export default cacheUI;
